import React from 'react';
import { IDataBox } from '../DataBox.types';
import { Container } from '../DataBox.styles';

export default function DataBoxRoot({ children, testId = 'data-box' }: IDataBox) {
  return <Container data-testid={testId}>{children}</Container>;
}
